__turbopack_context__.v({
  "consent": "readinessConsent-module-scss-module__609ClG__consent",
});
